<template>
  <div class="max-w-full md:mb-0 padding">
    <div class="relative">
      <div
        class="relative z-10 p-3 bg-cover md:p-10 md:h-[45rem]"
        style="background-image: url('/img/agency.jpg')"
      >
        <!-- Dark overlay on the background image -->
        <div class="absolute inset-0 bg-black bg-opacity-50"></div>

        <!-- Content that should not be covered by the overlay -->
        <div class="relative z-20 max-w-6xl mx-auto">
          <div class="flex flex-col md:items-center md:flex-row">
            <div class="flex-col hidden pl-4 md:w-6/12 md:flex">
              <h1 class="text-5xl font-extrabold text-white">
                Sell your home with confidence
              </h1>
              <p class="mt-5 text-white">
                Start connecting with active home seekers and gain exclusive
                member benefits.
              </p>
            </div>
            <div class="w-full md:w-6/12">
              <div
                class="p-5 px-4 bg-white rounded shadow w-12/12 md:w-[36rem]"
              >
                <h1 class="pt-3 text-2xl font-semibold">
                  Submit your details and we’ll get in touch
                </h1>
                <p
                  v-show="showMessage"
                  class="font-semibold text-center text-teal-600"
                >
                  {{ message }}
                </p>
                <div class="grid grid-cols-2 gap-5 pt-8">
                  <div class="col-span-2">
                    <label
                      for="company_name"
                      class="text-xs font-light text-gray-600 uppercase"
                      >Company Name *</label
                    >
                    <input
                      id="company_name"
                      type="text"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                      v-model="company_name"
                    />
                  </div>
                  <div class="">
                    <label
                      for="company_phone"
                      class="text-xs font-light text-gray-600 uppercase"
                      >Company phone number *</label
                    >
                    <input
                      id="company_phone"
                      type="text"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                      v-model="company_phone"
                    />
                  </div>
                  <div class="">
                    <label
                      for="company_phone"
                      class="text-xs font-light text-gray-600 uppercase"
                      >Company email address *</label
                    >
                    <input
                      id="company_email"
                      type="text"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                      v-model="company_email"
                    />
                  </div>
                  <div class="">
                    <label
                      for="address"
                      class="text-xs font-light text-gray-600 uppercase"
                      >Address *</label
                    >
                    <input
                      id="address"
                      type="text"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                      v-model="address"
                    />
                  </div>
                  <div>
                    <label
                      for="city_id"
                      class="text-xs font-light text-gray-600 uppercase"
                      >City *</label
                    >
                    <select
                      v-model="city_id"
                      id="city_id"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                    >
                      <option selected disabled>select city</option>
                      <option
                        :value="city.id"
                        v-for="city in cities"
                        :key="city.id"
                      >
                        {{ city.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label
                      for="job_title"
                      class="text-xs font-light text-gray-600 uppercase"
                      >Job Title *</label
                    >
                    <select
                      v-model="job_title"
                      id="job_title"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                    >
                      <option selected disabled>select job title</option>
                      <option value="CEO">CEO</option>
                      <option value="CFO">CFO</option>
                      <option value="CMO">CMO</option>
                      <option value="CTO">CTO</option>
                      <option value="Managing Director">
                        Managing Director
                      </option>
                      <option value="Finance Director">Finance Director</option>
                      <option value="Marketing Director">
                        Marketing Director
                      </option>
                      <option value="Director">Director</option>
                      <option value="Manager">Manager</option>
                      <option value="Sales Manager">Sales Manager</option>
                      <option value="Finance Manager">Finance Manager</option>
                      <option value="Marketing Manager">
                        Marketing Manager
                      </option>
                      <option value="Agent/Broker">Agent/Broker</option>
                      <option value="Admin">Admin</option>
                    </select>
                  </div>
                  <div>
                    <label
                      for="first_name"
                      class="text-xs font-light text-gray-600 uppercase"
                      >First Name *</label
                    >
                    <input
                      type="text"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                      v-model="first_name"
                      id="first_name"
                    />
                  </div>
                  <div>
                    <label
                      for="last_name"
                      class="text-xs font-light text-gray-600 uppercase"
                      >Last Name *</label
                    >
                    <input
                      type="text"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                      v-model="last_name"
                      id="last_name"
                    />
                  </div>
                  <div>
                    <label
                      for="email"
                      class="text-xs font-light text-gray-600 uppercase"
                      >Email *</label
                    >
                    <input
                      type="email"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                      v-model="email"
                      id="email"
                    />
                  </div>
                  <div>
                    <label
                      for="phone"
                      class="text-xs font-light text-gray-600 uppercase"
                      >Phone *</label
                    >
                    <input
                      type="tel"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                      v-model="phone"
                      id="phone"
                    />
                  </div>
                  <div>
                    <label
                      for="listing"
                      class="text-xs font-light text-gray-600 uppercase"
                      >listings per month *</label
                    >
                    <select
                      v-model="number_of_listings_per_month"
                      id="listing"
                      class="w-full h-10 p-2 shadow outline-none border-primary focus:outline bg-gray-50 focus:ring-0 focus:border-b"
                    >
                      <option selected disabled>
                        select listing per month
                      </option>
                      <option value="1-20">1 - 20</option>
                      <option value="21-40">1 - 40</option>
                      <option value="41-60">41 - 60</option>
                      <option value="61-80">61 - 80</option>
                      <option value="81-100">81 - 100</option>
                      <option value="100+">100+</option>
                    </select>
                  </div>
                  <div class="flex col-span-2">
                    <input
                      type="checkbox"
                      class="border border-[#ccc] rounded accent-primary"
                      v-model="accept"
                      value="accept"
                      id=""
                    />
                    <p class="pl-2 text-xs font-light tracking-wide">
                      I hereby accept the Terms & Conditions and consent to my
                      information being collected, processed and stored for
                      purposes of receiving marketing communication from
                      Hutloop.
                    </p>
                  </div>
                  <div class="col-span-2">
                    <button
                      @click="submitRequest"
                      class="w-24 p-2 mt-10 text-white uppercase rounded-sm bg-secondary h-14"
                    >
                      Submit
                    </button>
                    <p class="pt-3 text-[11px] font-light tracking-wide">
                      To advertise on Hutloop you should be a real estate broker
                      or developer and have a registered office.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-6xl px-5 mx-auto md:px-0">
      <div class="flex justify-center pl-4 mt-8 md:w-6/12">
        <h1 class="font-semibold tracking-normal text-gray-700 md:text-xl">
          Join Hutloop today, let us help you sell your home, your way. Register
          your agency with us to start selling. We have all the tools to help
          you with tracking how your properties or ads are doing, so come join
          us today.
        </h1>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      email: null,
      first_name: null,
      last_name: null,
      phone: null,
      number_of_listings_per_month: null,
      city_id: null,
      company_name: null,
      company_phone: null,
      company_email: null,
      address: null,
      base_url: this.$store.state.baseUrl,
      cities: null,
      message: null,
      showMessage: false,
      accept: null,
      job_title: null,
    };
  },
  mounted() {
    axios
      .get(`${this.base_url}cities`)
      .then((response) => {
        this.cities = response.data;
      })
      .catch((error) => console.log(error));
  },
  methods: {
    submitRequest() {
      axios
        .post(`${this.base_url}registration-enquiries`, {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          phone: this.phone,
          address: this.address,
          city_id: this.city_id,
          job_title: this.job_title,
          number_of_listings_per_month: this.number_of_listings_per_month,
          company_name: this.company_name,
          company_phone: this.company_phone,
          company_email: this.company_email,
        })
        .then((response) => {
          this.message = response.data.message;
          this.showMessage = true;
          (this.email = null),
            (this.first_name = null),
            (this.last_name = null),
            (this.phone = null),
            (this.number_of_listings_per_month = null),
            (this.city_id = null),
            (this.company_name = null),
            (this.company_email = null),
            (this.company_phone = null),
            (this.address = null),
            setTimeout(() => {
              this.message = null;
              this.showMessage = false;
            }, 5000);
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>
<style>
.padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
